export const focusVisibleClass =
  'outline-none focus:ring-transparent focus:ring-offset-0 focus:ring-0 focus-visible:ring-2 focus-visible:ring-offset-1 focus-visible:ring-[#1D76ED] focus-visible:ring-offset-bg-prim-w-b';
